// extracted by mini-css-extract-plugin
export var optionGrid = "_ax-7";
export var optionList = "_ax-6";
export var questionsBlock = "_ax-9";
export var spacer = "_ax-5";
export var stepCenteredContent = "_ax-3";
export var stepInner = "_ax-0";
export var stepInnerFullWidth = "_ax-1";
export var stepInnerLockScroll = "_ax-2";
export var stepTransitionFrame = "_ax-4";
export var welcomeBlock = "_ax-8";